import { useEffect } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { MiControlledTextField, MiModal } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { IBidResponse } from "@miplatform/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreateBidPayload } from "../../../../CreateBids.types";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
});

export function RenameTemplateModal({
  open,
  closeModal,
  selectedTemplate,
  updateAreaTemplate,
}: RenameTemplateModalProps) {
  const form = useForm<CreateBidPayload>({
    mode: "onChange",
    defaultValues: { name: "" },
    resolver: zodResolver(schema),
  });
  const { control, getValues, reset } = form;

  useEffect(() => {
    if (open && selectedTemplate) {
      reset(selectedTemplate);
    }
  }, [open]);

  const handleUpdateName = async () => {
    const data = getValues();
    const modifiedData = {
      ...data,
      planAreas: data.planAreas.map((a) => ({
        ...a,
        requiredCategories: [],
      })),
    };
    const successText = `${modifiedData.name} was updated successfully.`;
    await updateAreaTemplate(modifiedData, successText);
    closeModal();
  };

  return (
    <MiModal
      open={open}
      closeModal={closeModal}
      title="Rename Area Template"
      actions={[
        {
          name: "Cancel",
          color: BUTTON_COLORS.BLACK,
          variant: BUTTON_VARIANTS.TEXT,
          onClick: closeModal,
        },
        {
          name: "Save",
          variant: BUTTON_VARIANTS.CONTAINED,
          onClick: handleUpdateName,
        },
      ]}
    >
      <MiControlledTextField formControl={control} name="name" />
    </MiModal>
  );
}

interface RenameTemplateModalProps {
  open: boolean;
  closeModal: () => void;
  selectedTemplate: IBidResponse | null;
  updateAreaTemplate: (
    data: Partial<IBidResponse>,
    successText: string
  ) => Promise<void>;
}
